<template>
    <div class="book-button" @click.prevent="showDownloadAppPopUpContainer">
        <a class="button-container">
            <div class="button hd-18 white">{{$t('exchange-shop-details.book-button')}}<i class="far fa-angle-right"></i></div>
        </a>
    </div>
</template>

<script>
    import { isAndroid, isIOS } from 'mobile-device-detect';
    import {redirectToAppstore} from "../helper";

    export default {
        props: {
            text: String,
            locale: String
        },

        data(){
            return {

            }
        },

        computed: {

        },

        methods: {
            showDownloadAppPopUpContainer(){
                this.$events.$emit('download-app-pop-up-container:show');
            },
            bookingFX(){
                let locale = 'en';
                if (this.locale === 'zh-HK' || this.locale === "zh-CN")  {
                    locale = this.locale
                }
                const url = new URL(window.location.href = window.location.protocol + "//" + window.location.host + "/" + locale + "/travel-money-exchange/fx-booking");
                const exchange_id = new URL(location.href).searchParams.get('exchange_id');
                const shop_name = new URL(location.href).searchParams.get('shop');
                window.location.href = url + '?shop='+ shop_name + '&exchange_id=' + exchange_id;
            }
        },

        mounted() {

        }
    }
</script>

<style scoped lang="scss">
    .book-button{
        display: flex;
        .button-container{
            display: flex;
            align-items: center;
            .button {
                background: #59D876;
                border-radius: 4px;
                display: flex;
                align-items: center;
                border-color: transparent;
                &:hover{
                    color: #FFF;
                }
                .far{
                    padding-top: 4px;
                    margin-left: 4px;
                }
            }
        }
    }
</style>
